import { useOutletContext } from "react-router-dom";
import type { ICustomerMainLocation } from "../../customTypings/customer/Customer";
import type { CustomerAdminConfirmKind } from "../CustomersListPage/customerAdminListActions";

export type CustomerEditOutletContext = {
    siteId: string;
    customerId: string;
    customerName: string;
    mainLocation: ICustomerMainLocation | null;
    metaDeleted: boolean;
    metaEnabled: boolean;
    siteIsEnabled: boolean;
    siteIsDeleted: boolean;
    siteAccessLevel: 'readWrite' | 'readOnly' | 'none';
    readOnlyForm: boolean;
    setConfirmKind: (kind: CustomerAdminConfirmKind | null) => void;
};

export function useCustomerEditOutletContext(): CustomerEditOutletContext {
    return useOutletContext<CustomerEditOutletContext>();
}
